<a href="https://support.gatefy.com" class="floating-btn" target="_blank">
  <i class="fas fa-headset"></i>
  <p class="support-title">{{ 'support-contact' | translate: 'fe' }}</p>
</a>
